module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_01@3x-1503830528425b275c921f7140ce8b46.webp";